export default __webpack_public_path__ + "static/media/chim8.d4c14cd9.webp";